import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type {
  IInfiniteVisitHistoriesResponse,
  IVisitHistoriesParams,
} from "./types";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllVisitHistories");

type IResponse = IWithInfinite<IInfiniteVisitHistoriesResponse>;
type IVariables = IVisitHistoriesParams;

const getAllInfiniteVisitHistories = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(props), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteVisitHistories = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfiniteVisitHistories({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
